// extracted by mini-css-extract-plugin
export default {"lawyerList":"style_lawyerList__397TU","lawyer":"style_lawyer__9dTwz","photoCard":"style_photoCard__K9TDa","photo":"style_photo__oNz+t"};